var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctornowLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 26,
    viewBox: "0 0 98 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8036 0.00830078C41.6168 0.00830078 40.6552 0.978967 40.6552 2.17627V9.70543H39.2859C38.2164 9.70543 37.3496 10.5803 37.3496 11.6593C37.3496 12.7383 38.2164 13.6128 39.2859 13.6128H40.6552V23.3819C40.6552 24.5796 41.6168 25.5498 42.8036 25.5498C43.9908 25.5498 44.9525 24.5796 44.9525 23.3819V2.17627C44.9525 0.978967 43.9908 0.00830078 42.8036 0.00830078Z",
    fill: "#FF9700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9124 15.6113H3.39079C2.32129 15.6113 1.4541 16.4862 1.4541 17.5648C1.4541 18.6438 2.32129 19.5187 3.39079 19.5187H14.5509V23.4035C14.5509 24.6008 15.513 25.5715 16.6998 25.5715C17.8865 25.5715 18.8486 24.6008 18.8486 23.4035V17.7793C18.8486 17.7412 18.849 17.6718 18.849 17.6718C18.849 17.6718 18.8486 17.6029 18.8486 17.5648C18.8486 16.4862 17.9819 15.6113 16.9124 15.6113Z",
    fill: "#FF9700"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0:6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.966309H12.4721V13.4519H0V0.966309Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0:6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.536 13.4519C11.6055 13.4519 12.4723 12.577 12.4723 11.4985C12.4723 10.419 11.6055 9.54458 10.536 9.54458H3.90129V5.30224H10.3234C11.5106 5.30224 12.4723 4.33158 12.4723 3.13428C12.4723 1.93698 11.5106 0.966309 10.3234 0.966309H2.14887C1.82029 0.966309 1.51748 1.05384 1.23872 1.18688C0.514989 1.47461 0 2.17748 0 3.00991V11.4837C0 11.4863 0.00171806 11.4885 0.00171806 11.4911C0.00171806 11.4937 0 11.4959 0 11.4985C0 12.577 0.867192 13.4519 1.93668 13.4519H10.536Z",
    fill: "#FF9700"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1769 5.02407H18.9296V2.16797C18.9296 0.970666 17.9675 0 16.7807 0C15.594 0 14.6318 0.970666 14.6318 2.16797V2.4687V12.2503V12.5385C14.6318 13.5763 15.466 14.4179 16.4951 14.4179C16.5458 14.4179 16.6377 14.4183 16.6377 14.4183C16.6377 14.4183 16.73 14.4179 16.7807 14.4179C17.9675 14.4179 18.9296 13.4476 18.9296 12.2503V8.93143H20.1769C21.2464 8.93143 22.1131 8.05653 22.1131 6.97753C22.1131 5.89853 21.2464 5.02407 20.1769 5.02407Z",
    fill: "#FF9700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0463 18.3588H28.327V13.6099H34.5773C35.6468 13.6099 36.5136 12.735 36.5136 11.6564C36.5136 10.5774 35.6468 9.70253 34.5773 9.70253H28.327V5.30419H34.5503C35.7366 5.30419 36.6991 4.33353 36.6991 3.13623C36.6991 1.93893 35.7366 0.968262 34.5503 0.968262H26.2533C25.6404 0.968262 25.0954 1.2326 24.7041 1.64773C24.2922 2.0425 24.0293 2.59283 24.0293 3.21163V20.1012C24.0293 20.431 24.1143 20.7352 24.2449 21.0151C24.5258 21.7444 25.2186 22.2662 26.0407 22.2662H26.1627C26.1683 22.2662 26.1726 22.2688 26.1782 22.2688C26.1833 22.2688 26.1876 22.2662 26.1932 22.2662H36.0463C37.1153 22.2662 37.9825 21.3913 37.9825 20.3123C37.9825 19.2333 37.1153 18.3588 36.0463 18.3588Z",
    fill: "#FF9700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.812 0.00830078C68.9991 0.00830078 69.9608 0.978967 69.9608 2.17627V9.70543H71.3297C72.3996 9.70543 73.2664 10.5803 73.2664 11.6593C73.2664 12.7383 72.3996 13.6128 71.3297 13.6128H69.9608V23.3819C69.9608 24.5796 68.9991 25.5498 67.812 25.5498C66.6252 25.5498 65.6631 24.5796 65.6631 23.3819V2.17627C65.6631 0.978967 66.6252 0.00830078 67.812 0.00830078Z",
    fill: "#FF9700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2056 18.3748H53.3309V13.6264V9.719V5.32023L53.3301 5.31806V3.1358C53.3301 1.9385 52.3684 0.968262 51.1816 0.968262C50.0499 0.968262 49.1324 1.85399 49.0495 2.97373C49.0469 2.9928 49.0452 3.0123 49.0435 3.03136C49.0422 3.06646 49.0332 3.09983 49.0332 3.1358V3.22766V6.34246V20.1173C49.0332 20.447 49.1182 20.7512 49.2492 21.0316C49.5302 21.7605 50.223 22.2822 51.0451 22.2822H51.167C51.1726 22.2822 51.1765 22.2852 51.1821 22.2852C51.1877 22.2852 51.1915 22.2822 51.1971 22.2822H62.2056C63.2751 22.2822 64.1418 21.4073 64.1418 20.3287C64.1418 19.2497 63.2751 18.3748 62.2056 18.3748Z",
    fill: "#FF9700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5201 9.70074H82.0005C80.6098 9.70074 79.4827 8.56324 79.4827 7.16054C79.4827 5.75741 80.6098 4.61991 82.0005 4.61991H89.5201C90.9104 4.61991 92.0379 5.75741 92.0379 7.16054C92.0379 8.56324 90.9104 9.70074 89.5201 9.70074ZM90.3701 0.933105H81.1501C77.741 0.933105 74.9775 3.72117 74.9775 7.16054C74.9775 10.5999 77.741 13.388 81.1501 13.388H90.3701C93.7796 13.388 96.5431 10.5999 96.5431 7.16054C96.5431 3.72117 93.7796 0.933105 90.3701 0.933105Z",
    fill: "#FF9700"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0:6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 15,
    width: 24,
    height: 11
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3408 15.501H97.1785V25.7805H74.3408V15.501Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0:6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.695 18.728C96.704 18.7167 96.7134 18.7055 96.7224 18.6942C97.0029 18.3562 97.1786 17.9259 97.1786 17.4505C97.1786 17.0306 97.0441 16.6445 96.8208 16.3265C96.4944 15.832 95.9304 15.501 95.2771 15.501H95.0568H76.5047H76.2603C76.1366 15.501 76.0151 15.514 75.897 15.5391C75.01 15.7159 74.3408 16.5033 74.3408 17.4505C74.3408 18.5269 75.2059 19.4001 76.2732 19.4001C76.2887 19.4001 76.3028 19.3958 76.3187 19.3953C76.3802 19.3988 76.442 19.4031 76.5047 19.4031H83.6162V23.6078C83.6162 24.8389 84.5491 25.7805 85.7694 25.7805C86.9896 25.7805 87.923 24.8389 87.923 23.6078V19.4031H95.0568C95.1053 19.4031 95.1534 19.3979 95.2015 19.3953C95.217 19.3958 95.2312 19.4001 95.2462 19.4001C95.7285 19.4001 96.1649 19.2151 96.5034 18.9195C96.518 18.9074 96.5335 18.8961 96.5472 18.8827C96.6 18.8342 96.6481 18.7822 96.695 18.728Z",
    fill: "#FF9700"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctornowLogoText);
export default __webpack_public_path__ + "static/media/doctornowLogoText.c7f5cd683196b3c265a960522bf1f562.svg";
export { ForwardRef as ReactComponent };